var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "auto"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索客户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchSacTankRental
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadSacTankRental
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.AddTankRentalDrawer.openDrawer();
      }
    }
  }, [_vm._v("新增储罐租借")])], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "loading": _vm.tableLoading,
      "columns": _vm.columns,
      "data": _vm.tableData,
      "height": _vm.tableHeight
    }
  })], 1), _c('AddTankRentalDrawer', {
    ref: "AddTankRentalDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }